import React from "react";

const ChevronsUpDown = ({ style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36" }) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill={fill} className="u_fill"
            d="M16.738 2.449a2 2 0 0 1 2.676.136l8 8a2 2 0 1 1-2.828 2.829L18 6.828l-6.586 6.586a2 2 0 1 1-2.828-2.828l8-8 .152-.137ZM24.586 22.586a2 2 0 1 1 2.828 2.828l-8 8a2 2 0 0 1-2.828 0l-8-8a2 2 0 1 1 2.828-2.828L18 29.172l6.586-6.586Z"
        />
    </svg>
);

export default ChevronsUpDown;
